import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { FarmLocationsTable } from '@app/components/apps/FarmLocations/FarmLocationsTable';

const AllFarms: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  function handleCreateClick(): void {
    navigate('/register-farm');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: '/all-farms', breadcrumbName: 'My Establishments / Farms' }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Add Farm',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Register New Farm
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, []);

  return (
    <>
      <PageTitle>My Establishments / Farms</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FarmLocationsTable />
        </Col>
      </Row>
    </>
  );
};

export default AllFarms;
